import React from 'react';
import { Image } from 'react-bootstrap';
import LogoImg from "../images/ezguidelogo.svg";
import GooglePlay from "../images/google-play.png";
import AppStore from "../images/appstore-logo.png";

const FooterLogo = ({ hideDescription = false }) => {
  const goToAppStore = () => {
    window.open("https://apps.apple.com/us/app/ez1020/id6748396079", "_blank");
  };
  const goToPlaystore = () => {
    window.open("https://play.google.com/store/apps/details?id=com.ezguide", "_blank");
  };
  return (
    <>
      <div className="branding ">
        <div className="logo">
          <Image src={LogoImg} alt='' />
        </div>
        <p className="desc">
          Enjoy quicker access, a sleek interface, and seamless electrode placement guidance right from your phone.Download the ezGUIDE app now for the best experience on the go
        </p>
        {!hideDescription && (
          <div className="app-buttons">
            <Image src={GooglePlay} onClick={goToPlaystore} style={{ cursor: "pointer" }} alt='playstore' />
            <Image src={AppStore} onClick={goToAppStore} style={{ cursor: "pointer" }} alt='appstore' />
          </div>
        )}
      </div>
    </>
  )
}

export default FooterLogo